import { SizingGroup } from '../../models/sizing-group';
import presizeBackend from '../../services/presize-backend';
import presizeBackendRest from '../../services/presize-backend-rest';
import { mapRestDistributionToStore } from '../../lib/adapters/distribution-adapter';
import { isDbMigrated } from '../../lib/rest-feature-flag';
import { SizingStore } from './sizing-store';
import { SizeDistribution } from '../../models/response';

export class GetSizingDistributionAction {
  async getSizingDistribution(
    this: SizingStore,
    group: SizingGroup,
    referenceBrandCode?: string | null,
    silo?: string | null
  ): Promise<SizeDistribution> {
    const {
      commodityGroup: { code },
      commodityGroupCode,
      selectedSizeChart,
      selectedSizeKey,
      sizeStructure,
    } = group;
    if (!selectedSizeKey) {
      throw new Error('No selected size key could be found');
    }
    if (!selectedSizeChart) {
      throw new Error('No selected size chart could be found');
    }

    if (isDbMigrated()) {
      const restDist = await presizeBackendRest.getSizeDistribution({
        cg_code: commodityGroupCode,
        brand_code: referenceBrandCode || this.brandCode,
        season_code: this.seasonCode,
        size_structure: sizeStructure,
        size_chart_code: selectedSizeChart.sizeChartCode,
        length_chart_code: selectedSizeChart.lengthChartCode ?? null,
        size_keys: selectedSizeKey.sizeKeyId,
        silo: silo ?? null,
      });
      const mapped = mapRestDistributionToStore(restDist);
      return new SizeDistribution(
        mapped?.distribution ?? {},
        mapped?.distributionType ?? selectedSizeKey.distributionType!,
        mapped?.recoLevel,
        mapped?.recoStrategy
      );
    }

    return await presizeBackend.getDistribution(
      referenceBrandCode || this.brandCode,
      this.seasonCode,
      code,
      selectedSizeChart,
      selectedSizeKey,
      referenceBrandCode ? sizeStructure : undefined,
      silo
    );
  }
}
